<template>
  <div class="import-supplier-item-dialog">
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <div class="content">
        <el-popover
          placement="bottom-start"
          width="400"
          trigger="hover">
          <div class="text-list">
            您选择了
            <template v-for="item in outerIds" >
              <span :key="item.outerId">
                {{item.outerId}},
              </span>
            </template>
            已在商品资料中存在，请选择处理方式
          </div>
          <div class="text" slot="reference">您选择了{{outerId}}已在商品资料中存在，请选择处理方式</div>
        </el-popover>
        <div class="radio-form">
          <el-row class="first">
            <el-col>
              <el-radio v-model="replaceType" :label="0"
                >导入并新建商品</el-radio
              >
            </el-col>
            <el-col class="tips">系统会自动在款式编码后加上流水号，如AK28-1</el-col>
          </el-row>
          <el-radio v-model="replaceType" :label="1">跳过不导入该商品</el-radio>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfrim">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      replaceType:0,
      success: null,
      cancel: null,
      outerId:'',
      outerIds:[],
      type: ''
    };
  },
  methods: {
    method_open({success,cancel,data,type} = {}) {
      this.dialogVisible = true;
      this.success = success;
      this.cancel = cancel || null;
      this.outerId = data[0].outerId
      this.outerIds = data
      this.type = type || ''
    },
    handleConfrim() {
      if(this.type === 'single' && this.replaceType === 1) {
        this.dialogVisible = false
      } else {
        this.dialogVisible = false;
        this.success && this.success(this.replaceType)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.text{
  margin-bottom: 12px;
}
.first{
  margin-bottom: 12px;
}
.tips{
  color: #d0d2d4;
  padding-top: 8px;
  text-indent: 24px;
}
</style>
